module.exports = __webpack_public_path__ + "img/bookingconfirmation.62386fa5.jpg";